// removed by extract-text-webpack-plugin
module.exports = {"component":"_2qNGOzIzyCbUUnA7AP8G0n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Mobile/OneClickBuy/UserInfos/userInfos.css
// module id = 1229
// module chunks = 2